import React from "react";

const documentCategories = [
  {
    category: "Patient Intake Form",
    documents: [
      { id: 1, title: "Intake Form - May 2025.pdf" },
      { id: 2, title: "Updated Insurance Details.pdf" },
    ],
  },
  {
    category: "Patient Verification Checklist",
    documents: [
      { id: 3, title: "ID Verification Checklist.docx" },
      { id: 4, title: "Address Proof Checklist.pdf" },
    ],
  },
  {
    category: "Patient Form",
    documents: [
      { id: 5, title: "Medication Form.pdf" },
      { id: 6, title: "Allergy Disclosure Form.pdf" },
    ],
  },
];

export default function DocumentsTab() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-bold mb-6 text-gray-800">
        Patient Documents
      </h2>

      {documentCategories.map((section) => (
        <div key={section.category} className="mb-6">
          <h3 className="text-xl font-semibold text-gray-700 mb-2">
            {section.category}
          </h3>
          <ul className="space-y-2">
            {section.documents.map((doc) => (
              <li
                key={doc.id}
                className="p-3 bg-white border border-gray-200 rounded shadow-sm hover:bg-gray-50"
              >
                {doc.title}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
